/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlWelcomeTokenRequest
 */
export interface ControlWelcomeTokenRequest {
    /**
     * Time to token expiration in seconds
     * @type {number}
     * @memberof ControlWelcomeTokenRequest
     */
    expires_in?: number;
    /**
     * When true, requires the user to already exist in the database and not be active. Returns 202 if the user does not yet exist, signaling the request should be retried later.
     * @type {boolean}
     * @memberof ControlWelcomeTokenRequest
     */
    get_provisioned_account_token?: boolean;
}

/**
 * Check if a given object implements the ControlWelcomeTokenRequest interface.
 */
export function instanceOfControlWelcomeTokenRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlWelcomeTokenRequestFromJSON(json: any): ControlWelcomeTokenRequest {
    return ControlWelcomeTokenRequestFromJSONTyped(json, false);
}

export function ControlWelcomeTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlWelcomeTokenRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'expires_in': !exists(json, 'expires_in') ? undefined : json['expires_in'],
        'get_provisioned_account_token': !exists(json, 'get_provisioned_account_token') ? undefined : json['get_provisioned_account_token'],
    };
}

export function ControlWelcomeTokenRequestToJSON(value?: ControlWelcomeTokenRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'expires_in': value.expires_in,
        'get_provisioned_account_token': value.get_provisioned_account_token,
    };
}

